import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import './Categories.css'

type Props = {
  categories: any
  setCategories: any
}

export const Categories = ({ categories, setCategories }: Props) => {
  const { t } = useTranslation('filterBar')

  const categoriesPlaceholder = [
    'Weekend',
    'Week',
    'Summer camp',
    'Winter camp',
  ]

  const [selectedCategory, setSelectedCategory] = useState('')

  const handleCategoryChange = (selectedCategory: any) => {
    setSelectedCategory(selectedCategory)
    setCategories(selectedCategory)
  }

  return (
    <div id="will-filter-bar-categories">
      <h3 className="will-categories-filter-title">{t('categories.label')}</h3>

      <div className="will-categories-filter-inner">
        {categoriesPlaceholder.map((itm, idx) => (
          <div key={idx}>
            <input
              type="radio"
              value={itm}
              checked={selectedCategory === itm}
              onChange={() => handleCategoryChange(itm)}
            />
            <span>{itm}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

Categories.displayName = 'Categories'
